import { createSlice } from "@reduxjs/toolkit";


const certificationInitialState = {
    currentCertification : null,
    totalEmission : 0,
    selectedUser : null,
};

const certificationSlice = createSlice({
    name : 'certificate',
    initialState : certificationInitialState,
    reducers : {
        setCurrentCertification : (state, action) => {
            state.currentCertification = action.payload;
        },
        setTotalEmissionForReport : (state, action) => {
         
            state.totalEmission = action.payload;
        },

        setSelectedUser : (state, action) => {
            state.selectedUser = action.payload;
        }
    }
});

export const {setCurrentCertification, setTotalEmissionForReport, setSelectedUser} = certificationSlice.actions;
export default certificationSlice.reducer;